export default function WarningIcon({ width = 36, height = 36 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 16.875H18V24.75H19.125M31.5 18C31.5 25.4558 25.4558 31.5 18 31.5C10.5442 31.5 4.5 25.4558 4.5 18C4.5 10.5442 10.5442 4.5 18 4.5C25.4558 4.5 31.5 10.5442 31.5 18Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7188 13.5C18.6507 13.5 19.4062 12.7445 19.4062 11.8125C19.4062 10.8805 18.6507 10.125 17.7188 10.125C16.7868 10.125 16.0312 10.8805 16.0312 11.8125C16.0312 12.7445 16.7868 13.5 17.7188 13.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
